import { Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import MuniDetail from "./pages/MuniDetail"; // Create MuniDetail component
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Account from "./pages/Account";
import { AuthContextProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ForgotPassword from "./pages/ForgotPassword";
import { PurchasedPricesProvider } from "./context/PurchasedPricesContext";
import Footer from "./components/Footer";
import Privacy from "./pages/Privacy";
import Contact from "./pages/Contact";
import SystemRequirements from "./pages/SystemRequirements";
import ScrollToTop from "./components/ScrollToTop";
import Faq from "./pages/Faq";

function App() {
  return (
    <>
      <AuthContextProvider>
        <PurchasedPricesProvider>
          <Navbar />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route
              path="/account"
              element={
                <ProtectedRoute>
                  {" "}
                  <Account />{" "}
                </ProtectedRoute>
              }
            />
            <Route path="/fc/:id" element={<MuniDetail />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<Faq />} />
            <Route
              path="/systemrequirements"
              element={<SystemRequirements />}
            />
          </Routes>
          <Footer />
        </PurchasedPricesProvider>
      </AuthContextProvider>
    </>
  );
}

export default App;
